import { render } from "./AreaAcademica.vue?vue&type=template&id=3d2c21e3"
import script from "./AreaAcademica.vue?vue&type=script&lang=js"
export * from "./AreaAcademica.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__